import PageSelforderingLogin from '@/pages/PageSelforderingLogin'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: PageSelforderingLogin,
		vueInit: null,
	}

	let page = vuewidget(dom, options)
	return page
}